import {
  AutocompleteProps as MantineAutocompleteProps,
  Autocomplete as MantineAutocomplete,
} from '@mantine/core';

export type AutocompleteProps = MantineAutocompleteProps;

export const Autocomplete = MantineAutocomplete;

Autocomplete.displayName = 'Autocomplete';
